import Table from '@material-ui/core/Table';
import React from 'react';
import styled from 'styled-components';

export const TableContainer = styled((props) => <Table {...props} />)`
  background: white;
`;
